<template>
  <svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
   viewBox="0 0 274.3 275.2" style="enable-background:new 0 0 274.3 275.2;" xml:space="preserve">
    <g>
      <defs>
        <rect id="r4_1_" y="80.9" width="113.4" height="113.4"/>
      </defs>
      <clipPath id="r4_2_">
        <use xlink:href="#r4_1_"  style="overflow:visible;"/>
      </clipPath>
      <g class="st0">
        <g>
          <defs>
            <path id="r4_3_" d="M0,185.3V89.9c0-2.4,0.9-4.7,2.6-6.4c1.7-1.7,4-2.6,6.4-2.6h95.4c2.4,0,4.7,0.9,6.4,2.6
              c1.7,1.7,2.6,4,2.6,6.4v95.4c0,2.4-0.9,4.7-2.6,6.4s-4,2.6-6.4,2.6H9c-2.4,0-4.7-0.9-6.4-2.6C0.9,190,0,187.7,0,185.3z"/>
          </defs>
          <clipPath id="r4_4_">
            <use xlink:href="#r4_3_"  style="overflow:visible;"/>
          </clipPath>
          <g class="st1">
            <path class="st2" d="M0,194.3V80.9h113.4v113.4H0z"/>
          </g>
        </g>
      </g>
    </g>
    <g>
      <defs>
        <rect id="r4_5_" x="160.9" y="80.9" width="113.4" height="113.4"/>
      </defs>
      <clipPath id="r4_6_">
        <use xlink:href="#r4_5_"  style="overflow:visible;"/>
      </clipPath>
      <g class="st3">
        <g>
          <defs>
            <path id="r4_7_" d="M160.9,185.3V89.9c0-2.4,0.9-4.7,2.6-6.4c1.7-1.7,4-2.6,6.4-2.6h95.4c2.4,0,4.7,0.9,6.4,2.6
              c1.7,1.7,2.6,4,2.6,6.4v95.4c0,2.4-0.9,4.7-2.6,6.4c-1.7,1.7-4,2.6-6.4,2.6h-95.4c-2.4,0-4.7-0.9-6.4-2.6
              S160.9,187.7,160.9,185.3z"/>
          </defs>
          <clipPath id="r4_8_">
            <use xlink:href="#r4_7_"  style="overflow:visible;"/>
          </clipPath>
          <g class="st4">
            <path class="st2" d="M160.9,194.3V80.9h113.4v113.4H160.9z"/>
          </g>
        </g>
      </g>
    </g>
    <g>
      <defs>
        <rect id="r4_9_" x="85.2" y="80.9" width="113.4" height="113.4"/>
      </defs>
      <clipPath id="r4_10_">
        <use xlink:href="#r4_9_"  style="overflow:visible;"/>
      </clipPath>
      <g class="st5">
        <g>
          <defs>
            <path id="r4_11_" d="M85.2,185.3V89.9c0-2.4,0.9-4.7,2.6-6.4c1.7-1.7,4-2.6,6.4-2.6h95.4c2.4,0,4.7,0.9,6.4,2.6
              c1.7,1.7,2.6,4,2.6,6.4v95.4c0,2.4-0.9,4.7-2.6,6.4c-1.7,1.7-4,2.6-6.4,2.6H94.2c-2.4,0-4.7-0.9-6.4-2.6S85.2,187.7,85.2,185.3z
              "/>
          </defs>
          <clipPath id="r4_12_">
            <use xlink:href="#r4_11_"  style="overflow:visible;"/>
          </clipPath>
          <g class="st6">
            <path class="st2" d="M85.2,194.3V80.9h113.4v113.4H85.2z"/>
          </g>
        </g>
      </g>
    </g>
    <g>
      <defs>
        <rect id="r4_13_" x="80.9" width="113.4" height="113.4"/>
      </defs>
      <clipPath id="r4_14_">
        <use xlink:href="#r4_13_"  style="overflow:visible;"/>
      </clipPath>
      <g class="st7">
        <g>
          <defs>
            <path id="r4_15_" d="M89.9,0h95.4c2.4,0,4.7,0.9,6.4,2.6c1.7,1.7,2.6,4,2.6,6.4v95.4c0,2.4-1,4.7-2.6,6.4s-4,2.6-6.4,2.6
              H89.9c-2.4,0-4.7-0.9-6.4-2.6s-2.6-4-2.6-6.4V9c0-2.4,1-4.7,2.6-6.4C85.2,0.9,87.5,0,89.9,0z"/>
          </defs>
          <clipPath id="r4_16_">
            <use xlink:href="#r4_15_"  style="overflow:visible;"/>
          </clipPath>
          <g class="st8">
            <path class="st2" d="M80.9,0h113.4v113.4H80.9V0z"/>
          </g>
        </g>
      </g>
    </g>
    <g>
      <defs>
        <rect id="r4_17_" x="80.9" y="161.8" width="113.4" height="113.4"/>
      </defs>
      <clipPath id="r4_18_">
        <use xlink:href="#r4_17_"  style="overflow:visible;"/>
      </clipPath>
      <g class="st9">
        <g>
          <defs>
            <path id="r4_19_" d="M89.9,161.8h95.4c2.4,0,4.7,0.9,6.4,2.6s2.6,4,2.6,6.4v95.4c0,2.4-1,4.7-2.6,6.4c-1.7,1.7-4,2.6-6.4,2.6
              H89.9c-2.4,0-4.7-0.9-6.4-2.6c-1.7-1.7-2.6-4-2.6-6.4v-95.4c0-2.4,1-4.7,2.6-6.4S87.5,161.8,89.9,161.8z"/>
          </defs>
          <clipPath id="r4_20_">
            <use xlink:href="#r4_19_"  style="overflow:visible;"/>
          </clipPath>
          <g class="st10">
            <path class="st2" d="M80.9,161.8h113.4v113.4H80.9V161.8z"/>
          </g>
        </g>
      </g>
    </g>
    <g>
      <defs>
        <rect id="r4_21_" x="10.9" y="10.9" width="253.4" height="253.4"/>
      </defs>
      <clipPath id="r4_22_">
        <use xlink:href="#r4_21_"  style="overflow:visible;"/>
      </clipPath>
      <g class="st11">
        <g>
          <defs>
            <circle id="r4_23_" cx="137.6" cy="137.6" r="126.7"/>
          </defs>
          <clipPath id="r4_24_">
            <use xlink:href="#r4_23_"  style="overflow:visible;"/>
          </clipPath>
          <g class="st12">
            <path class="st13" d="M10.9,10.9h253.4v253.4H10.9V10.9z"/>
          </g>
        </g>
      </g>
    </g>
    <g>
      <defs>
        <rect id="r4_25_" x="62.7" y="62.7" width="149.8" height="149.8"/>
      </defs>
      <clipPath id="r4_26_">
        <use xlink:href="#r4_25_"  style="overflow:visible;"/>
      </clipPath>
      <g class="st14">
        <g>
          <defs>
            <circle id="r4_27_" cx="137.6" cy="137.6" r="74.9"/>
          </defs>
          <clipPath id="r4_28_">
            <use xlink:href="#r4_27_"  style="overflow:visible;"/>
          </clipPath>
          <g class="st15">
            <path class="st2" d="M62.7,62.7h149.8v149.8H62.7V62.7z"/>
          </g>
        </g>
      </g>
    </g>
  </svg>
</template>

<script>
  export default {
    name: 'r4'
  }
</script>

<style scoped>
  svg {
    width: 100%;
    height: 100%;
  }
</style>

<style scoped>
  .st0{clip-path:url(#r4_2_);}
  .st1{clip-path:url(#r4_4_);}
  .st2{fill:#2C6EDF;}
  .st3{clip-path:url(#r4_6_);}
  .st4{clip-path:url(#r4_8_);}
  .st5{clip-path:url(#r4_10_);}
  .st6{clip-path:url(#r4_12_);}
  .st7{clip-path:url(#r4_14_);}
  .st8{clip-path:url(#r4_16_);}
  .st9{clip-path:url(#r4_18_);}
  .st10{clip-path:url(#r4_20_);}
  .st11{clip-path:url(#r4_22_);}
  .st12{clip-path:url(#r4_24_);}
  .st13{fill:#75A0F1;}
  .st14{clip-path:url(#r4_26_);}
  .st15{clip-path:url(#r4_28_);}
</style>



// WEBPACK FOOTER //
// src/components/Dashboard/Views/PosSettings/svg/r4.vue